enum Error {
  PagingParametersChanged = 'Paging parameters were changed',
  GetItemsFailure = 'Unable to get items',
  InvalidPageNumber = 'Invalid page number',
}

export default Error;
